import { Template, TemplateLocalization } from "../model/Template";
import { Language } from "../model/Language";

/**
 * Convert Template with Map<Language, TemplateLocalization> to Template with Set<TemplateLocalization> for backend
 */
export function templateToBackendFormat(template: Template): Omit<Template, 'localizations'> & { localizations: TemplateLocalization[] } {
    const localizations = Object.values(template.localizations);
    return {
        ...template,
        localizations: localizations
    };
}

/**
 * Convert Template with Set<TemplateLocalization> from backend to Template with Map<Language, TemplateLocalization> for frontend
 */
export function templateFromBackendFormat(template: Template & { localizations: TemplateLocalization[] }): Template {
    const localizationsMap = template.localizations.reduce((acc, loc) => {
        acc[loc.language] = loc;
        return acc;
    }, {} as Record<Language, TemplateLocalization>);
    
    return {
        ...template,
        localizations: localizationsMap
    };
}
